import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { moneyFormat } from "../../util/format.js";
import axios from "axios";
import { toast } from "react-toastify";
import "./ProductCard.css";
export const ProductCard = ({ product, viewMode = "grid" }) => {
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");

  const image = product?.imagesUrl?.[0];

  const handleAddToCart = (e) => {
    e.preventDefault();

    const productId = product?.id;
    const name = product?.name;
    const price = product?.salePrice;
    const imageToCart = image;

    const existingCart = JSON.parse(localStorage.getItem("cart")) || [];

    const existingItemIndex = existingCart.findIndex(
      (item) => item.productId === productId,
    );

    if (existingItemIndex !== -1) {
      existingCart[existingItemIndex].quantity += 1;
    } else {
      existingCart.push({
        productId,
        quantity: 1,
        name,
        price,
        image: imageToCart,
      });
    }

    localStorage.setItem("cart", JSON.stringify(existingCart));
    window.dispatchEvent(new Event("cartUpdated"));
    toast.success("Thêm vào giỏ hàng thành công");

    navigate("/cart");
  };

  const handleAddToWishList = (e) => {
    e.preventDefault();
    if (!userId) {
      toast.error("Vui lòng đăng nhập");
      return;
    }
    axios
      .post("/wish-list/" + product?.id)
      .then(() => {
        toast.success("Thêm vào yêu thích thành công");
      })
      .catch((err) => {
        console.log(err);
        if (err.response?.data?.status === 400) {
          toast.error(err.response.data.messages.message);
        }
      });
  };

  return (
    <div
      className={`product-item ${
        viewMode === "list" ? "list-view" : "grid-view"
      }`}
    >
      <div
        className={`product-inner ${
          viewMode === "list" ? "list-layout" : "grid-layout"
        }`}
      >
        <div
          className={`product-img position-relative overflow-hidden ${
            viewMode === "list" ? "list-img" : "grid-img"
          }`}
        >
          <Link to={`/san-pham/${product.slug}`} className="d-block h-100">
            <img
              className="img-fluid w-100 h-100"
              src={image}
              alt={product.name}
              style={{
                objectFit: "cover",
              }}
            />
          </Link>
        </div>

        <div className="product-content">
          <Link
            className="h6 text-decoration-none text-truncate mb-3 d-block"
            to={`/san-pham/${product.slug}`}
          >
            {product.name}
          </Link>
          <div className="price-container mb-3">
            <h5 className="text-red-500 font-bold">
              {moneyFormat(product.salePrice)}
            </h5>
            {product.originalPrice && (
              <h6 className="text-muted ml-2 line-through">
                <del>{moneyFormat(product.originalPrice)}</del>
              </h6>
            )}
          </div>
          <div className="d-flex justify-content-between">
            <button className="btn btn-danger mr-2" onClick={handleAddToCart}>
              <i className="fa fa-shopping-cart mr-1"></i> Mua ngay
            </button>

            {product.wishLists?.some(
              (wishList) => wishList.userId === Number(userId),
            ) ? (
              <>
                <button className="btn btn-outline-danger hover:text-slate-300">
                  <i className="fa fa-heart text-danger"></i> Đã yêu thích
                </button>
              </>
            ) : (
              <button
                className="btn btn-outline-danger hover:text-slate-300"
                onClick={handleAddToWishList}
              >
                <i className="far fa-heart"></i> Yêu thích
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
